// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qz_v","title":"Header_title__2kCnJ","left":"Header_left__2BXSL","clinicName":"Header_clinicName__ojgbI"};